import { render, staticRenderFns } from "./RequestTypeSearch.vue?vue&type=template&id=27f00c55"
import script from "./RequestTypeSearch.vue?vue&type=script&lang=js"
export * from "./RequestTypeSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports